import {
  Button,
  ButtonGroup,
  Popover,
  useTheme,
  alpha,
  IconButton,
  PopoverOrigin,
} from "@mui/material";
import { CircleX, Trash2, Archive } from "lucide-react";
import React from "react";
import { bindPopper, PopupState } from "material-ui-popup-state/hooks";

interface DeleteArchiveConfirmationTooltipButtonProps {
  closeDialog: (event) => void;
  confirmAction: (event) => void;
  popupState: PopupState;
  anchorOrigin?: PopoverOrigin;
  transformOrigin?: PopoverOrigin;
  deleteItem: boolean;
}

export const DeleteArchiveConfirmationTooltipButton = ({
  closeDialog,
  confirmAction,
  popupState,
  anchorOrigin = { vertical: "bottom", horizontal: "center" },
  transformOrigin = { vertical: "top", horizontal: "center" },
  deleteItem = true,
}: DeleteArchiveConfirmationTooltipButtonProps) => {
  const theme = useTheme();

  return (
    <Popover
      anchorOrigin={anchorOrigin}
      transformOrigin={transformOrigin}
      hideBackdrop={false}
      onClose={closeDialog}
      {...bindPopper(popupState)}
      sx={{
        zIndex: 999999999,
        ".MuiPaper-root": {
          borderRadius: 2,
        },
      }}
    >
      <ButtonGroup variant="outlined" size="small">
        <Button
          color="error"
          startIcon={deleteItem ? <Trash2 /> : <Archive />}
          sx={{
            color: theme.palette.error.contrastText,
            background: theme.palette.error.light,
            borderColor: theme.palette.error.light,
            ":hover": {
              background: alpha(theme.palette.error.light, 0.8),
              borderColor: alpha(theme.palette.error.light, 0.8),
              borderRightColor: alpha(theme.palette.error.light, 0.8),
            },
          }}
          style={{
            marginRight: "1px",
            borderRightWidth: "2px",
            borderRightColor: theme.palette.error.light,
          }}
          onClick={confirmAction}
        >
          Confirm {deleteItem ? "delete" : "archive"}
        </Button>
        <IconButton
          size="small"
          sx={{
            borderRadius: "unset",
            color: theme.palette.text.primary,
          }}
          onClick={closeDialog}
        >
          <CircleX />
        </IconButton>
      </ButtonGroup>
    </Popover>
  );
};
